export enum ToolbarStyle {
  Clear = 'Clear',
  Standard = 'Standard'
}
